import type { ReactNode } from 'react';

import * as styles from './Menu.css';

interface MenuProps {
  children: ReactNode;
}

export const Menu: React.FC<MenuProps> = ({ children }) => {
  return (
    <div role="menu" className={styles.menu}>
      {children}
    </div>
  );
};
